<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t("incomming_stock_transfer")}}</h4>
                <p class="text-subtitle-1">{{$t("incoming_stock_transfer_from_other_warehouses")}}</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3">
                <v-text-field
                    :label="$t('search')"
                    v-model="search.code"
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    rounded
                    dense
                    hide-details
                    @input="handleSearchByCode"
                    ></v-text-field>  
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                    dense
                    :headers="headers"
                    :items="data"
                    disable-sort
                    :page.sync="page"
                    :options.sync="options"
                    :loading="loading"
                    :server-items-length="serverItemsLength"
                    >
                    <template v-slot:[`item.code`]="{item}">
                        <v-btn icon @click="handleDisplay(item)">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        {{item.code}}
                    </template>
                    <template v-slot:[`item.state`]="{item}">
                        <PStatus :state="item.state"/>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import stockTransferAPI from '../../../services/stockJournal/stockTransfer';
import PStatus from './../../../components/common/PStatus.vue'

export default {
    components: {
        PStatus
    },
    data() {
        return {
            data: [],
            options: {},
            search: {},
            page: 1,
            serverItemsLength: 0,
            loading: false,
            warehouseId: null,
            stateCodePosted: 3
        }
    },
    computed: {
        headers() {
            return [
                { text: this.$t("code"), value: "code" },
                { text: this.$t("date"), value: "date" },
                { text: this.$t("source_warehouse"), value: "source_warehouse" },
                { text: this.$t("created_by"), value: "created_by" },
            ]
        }
    },
    watch: {
        options: {
            deep: true,
            handler() {
                this.fetch();
            }
        }
    },
    methods: {
        fetch() {
            this.loading = true;
            this.data = [];
            stockTransferAPI.index({...this.options, ...this.search, target_warehouse_id: this.warehouseId, state_code: this.stateCodePosted}).then(response => {
                this.data = response.data.data;
                this.serverItemsLength = response.data.count;
            }).finally(() => {
                this.loading = false;
            })
        },
        handleDisplay(item) {
            this.$router.push({
                name: "TransferIssueVoucherDisplay",
                params: {
                    id: item.id
                }
            })
        },
        handleSearchByCode() {
            this.fetch();
        }
    },
    created() {
        this.warehouseId = this.$route.params.warehouseId
    }
}
</script>

<style>

</style>